var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumber2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.137 28H4.63v-3.555l4.88-4.935c1.395-1.459 2.307-2.452 2.735-2.98.428-.539.725-.999.889-1.382.173-.382.26-.783.26-1.203 0-.52-.17-.93-.506-1.23-.338-.3-.811-.451-1.422-.451-.63 0-1.267.182-1.914.546-.638.356-1.363.885-2.174 1.586l-2.967-3.472c1.03-.92 1.896-1.577 2.598-1.969a9.138 9.138 0 012.283-.916c.83-.21 1.76-.314 2.789-.314 1.294 0 2.447.227 3.459.683 1.02.456 1.81 1.108 2.365 1.955.565.839.848 1.782.848 2.83 0 .784-.1 1.509-.3 2.174a7.606 7.606 0 01-.903 1.969c-.41.638-.957 1.312-1.64 2.023-.675.711-2.12 2.06-4.335 4.047v.137h7.56V28z",
    fill: "#fff",
    fillOpacity: 0.2
  })));
}

export default SvgNumber2;